import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-small-progress-bar',
  templateUrl: './small-progress-bar.component.html',
  styleUrls: ['./small-progress-bar.component.css']
})
export class SmallProgressBarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
